import { create } from 'zustand'

/**
 * 현재 보고 있는 구장의 **표시용 미러**.
 *
 * 🚨 진실의 원천은 URL(`/venues/:venueId/...`)이다. 이 스토어는 셸(사이드바)이
 * 페이지가 이미 받아온 `venueName` 을 보여주기 위한 통로일 뿐이며, 인가·조회 대상 결정에
 * 쓰지 않는다.
 */
interface VenueState {
  venueId: string | null
  venueName: string | null
  setCurrentVenue: (venue: { venueId: string; venueName: string }) => void
  clearCurrentVenue: () => void
}

export const useVenueStore = create<VenueState>((set) => ({
  venueId: null,
  venueName: null,
  setCurrentVenue: ({ venueId, venueName }) => {
    set({ venueId, venueName })
  },
  clearCurrentVenue: () => {
    set({ venueId: null, venueName: null })
  },
}))
